// appart-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Baixar esta placa": "Descargar esta placa",
    "Encolhe o QR dentro do quadro, abrindo margem branca em volta. Vale para esta placa e para o zip.": "Reduce el QR dentro del cuadro, dejando margen blanco alrededor. Aplica para esta placa y para el zip.",
    "Monta as telas do app com a arte atrás e o chrome ajustável": "Arma las pantallas de la aplicación con el arte detrás y el chrome ajustable",
    "O QR aponta para": "El QR apunta a",
    "Tamanho do QR": "Tamaño del QR",
    "Todas as placas de um posto de uma vez": "Todas las placas de una estación de una vez",
};

export default catalogo;
